import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';

interface DangerZoneProps {
    deleteTo: string;
    description?: string;
    archived?: boolean;
    onArchive?: () => void;
    onUnarchive?: () => void;
    archiveLoading?: boolean;
    archiveTitle?: string;
    unarchiveTitle?: string;
}

function DangerZone(props: DangerZoneProps) {
    const {
        deleteTo,
        description,
        archived,
        onArchive,
        onUnarchive,
        archiveLoading,
        archiveTitle,
        unarchiveTitle,
    } = props;
    const { t } = useTranslation();

    return (
        <div className="mt-10 rounded-md border border-red-200 bg-red-50 dark:bg-red-950/30 p-4">
            <h3 className="text-sm font-semibold text-red-800">
                {t('common.danger_zone')}
            </h3>
            <p className="mt-1 text-sm text-red-700">
                {description || t('common.danger_zone_delete_hint')}
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
                {(onArchive || onUnarchive) && (
                    <Button
                        onClick={archived ? onUnarchive : onArchive}
                        title={archived
                            ? (unarchiveTitle || t('projects.unarchive'))
                            : (archiveTitle || t('projects.archive'))}
                        color={archived ? 'secondary' : 'warning'}
                        icon={archived ? 'unarchive' : 'archive'}
                        disabled={archiveLoading}
                    />
                )}
                <Button
                    to={deleteTo}
                    title={t('common.delete')}
                    color="danger"
                    icon="delete"
                />
            </div>
        </div>
    );
}

export default DangerZone;
